import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Box, CircularProgress, Typography, styled } from "@mui/material";
import { useEffect } from "react";
import { getCoinVelocity } from "../Services/apiRoutes";
import { SocialIcon } from "react-social-icons";
import { Icon } from "./Icon";
import { MarketRate } from "./MarketRate";
import { getCryptoLogoMap } from "../utils/utility";
import CoinVelocitySentimentTable from "../Sections/Reviews/CoinVelocitySentimentTable"
import ToolTip from "../components/ToolTip";
import QuestionMarkSvg from '../components/QuestionMarkSvg'

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#D5B458",
    color: theme.palette.common.black,
    padding: "10px 20px",
    borderRight: "1px solid #FFFFFF",
    fontFamily: "Inter",
    marginTop: "2px",
    fontWeight: "800",
    align: "center",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 20,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

let coinSymbol = [];

export default function CoinVelocityTable() {
  const [rows, setRows] = React.useState([]);
  const [iconURL, setIconURL] = React.useState({});
  const [loading, setLoading] = React.useState(true);
  const [toggleTable, setToggleTable] = React.useState(false);
  const [sentimentCoin, setSentimentCoinType] = React.useState("top");

  useEffect(() => {
    fetchCoinChannelData();
  }, []);

  // Below code is for check screen-size;
  const [isMobile, setIsMobile] = React.useState(false);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    // Add event listener to handle window resize
    window.addEventListener('resize', handleResize);

    // Initial check for mobile
    setIsMobile(window.innerWidth <= 768);

    // Clean up event listener
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  //End  

  function createRowData(index, coin, count, channels, velocity, type) {
    velocity = Number(velocity)?.toFixed(0);
    return { index, coin, count, channels, velocity, type };
  }
  const fetchCoinChannelData = async () => {
    try {
      const data = await getCoinVelocity();
      let index = 0;
      let dataList = [];

      data['data']['exuberant'].forEach((element) => {
        dataList.push(createRowData(index++, element.coin, element.count, element.channels, element.percentile_rank, "Exuberant"));
      });

      data['data']['trending'].forEach((element) => {
        dataList.push(createRowData(index++, element.coin, element.count, element.channels, element.percentile_rank, "Trending"));
      });

      data['data']['engaging'].forEach((element) => {
        dataList.push(createRowData(index++, element.coin, element.count, element.channels, element.percentile_rank, "Engaging"));
      });

      data['data']['curious'].forEach((element) => {
        dataList.push(createRowData(index++, element.coin, element.count, element.channels, element.percentile_rank, "Curious"));
      });

      data['data']['neutral'].forEach((element) => {
        dataList.push(createRowData(index++, element.coin, element.count, element.channels, element.percentile_rank, "Neutral"));
      });
      dataList = dataList.slice(0, 10);
      pushCoins(dataList);
      getCoinData();
      setRows(dataList);
    } catch (error) {
      console.log("error ocuured", error);
    } finally {
      setLoading(false);
    }
  };
  const getCoinData = async () => {
    var result = await getCryptoLogoMap(coinSymbol);
    setIconURL(result);
    return result;
  };

  const pushCoins = (dataArray) => {
    dataArray.forEach((data) => {
      return coinSymbol.push(data.coin);
    });
  };

  const onRowClick = (coin) => {
    window.history.pushState(null, '', window.location.href);
    window.onpopstate = () => {
      window.onpopstate = undefined;
      setToggleTable(false);
    }

    setSentimentCoinType(coin);
    setToggleTable(true);
  };


  const onCoinVelocityCardPageClose = () => {
    window.onpopstate = undefined;
    window.history.back();
    setToggleTable(false);
  };

  // const revivalBack = () => {
  //   window.onpopstate = undefined;
  //   window.history.back();
  // };
  // const neutralizeBack = () => {
  //   window.history.pushState(null, "", window.location.href);
  //   window.onpopstate = () => {
  //     window.history.pushState(null, "", window.location.href);
  //   };
  // };

  return (

    <>
      {toggleTable ? (

        <CoinVelocitySentimentTable coin={sentimentCoin} onClose={onCoinVelocityCardPageClose} />


      ) : (
        <Box position="relative" maxWidth="900px" margin="20px auto">


          <ToolTip arrow title={"At Auro Digital we listen to  what’s Trending in  Crypto and Digital Assets, on news and social media channels, that we correlate with Price action and share with our clients as ideational tools."} placement="top" enterTouchDelay={0}>

            <Box sx={{ display: "flex", alignItems: "center", flexDirection: "row", justifyContent: "center", marginTop: "10px", marginBottom: "30px" }}>
              <Typography sx={{ fontWeight: "bold", textAlign: "center" }} variant={isMobile ? "h5" : "h4"}>
                Coin Velocity
              </Typography>
              <div style={{ marginLeft: "5px" }}>
                {
                  isMobile ?
                    (
                      <QuestionMarkSvg />
                    ) : (
                      <div />
                    )}
              </div>
            </Box>
          </ToolTip>

          {loading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: "50px",
                marginLeft: "auto",
                marginRight: "auto",
              }}
            >
              <CircularProgress />
            </div>
          ) : (
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
                <TableHead
                  style={{
                    backgroundColor: "black",
                    color: "white",
                  }}
                >
                  <TableRow>
                    <StyledTableCell>#</StyledTableCell>
                    <StyledTableCell align="center" fontWeight="bold">Coin</StyledTableCell>
                    <StyledTableCell align="center">Channel</StyledTableCell>
                    <StyledTableCell align="center">Rating</StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rows.map((row) => (
                    <StyledTableRow onClick={() => onRowClick(row.coin.toUpperCase())} key={row.index}>

                      <StyledTableCell component="th" scope="row">
                        {row.index + 1}
                      </StyledTableCell>

                      <StyledTableCell align="center" component="th" scope="row">
                        <Box display="inline-flex" alignItems="center" gap={1}>
                          <Box>
                            <Icon url={iconURL[row.coin.toUpperCase()] ?? ""} />
                          </Box>
                          <Box>
                            <Typography fontWeight="600" fontSize={20}>
                              {row.coin}
                            </Typography>
                          </Box>
                        </Box>
                      </StyledTableCell>

                      <StyledTableCell align="center">
                        {
                          <Box sx={{ display: "flex", gap: "8px", width: "max-content", margin: "auto" }}>
                            {row.channels.map?.((coin) => (

                              <SocialIcon
                                network={coin.toLowerCase()}
                                style={{
                                  width: "22px",
                                  height: "22px",
                                }}
                              />

                            ))}
                          </Box>

                        }
                      </StyledTableCell>

                      <StyledTableCell align="center" component="th" scope="row">
                        <Box display="inline-flex" alignItems="center" gap={3}>
                          <Box>
                            <Typography fontSize={20} >{row.type}</Typography>
                          </Box>
                          <Box>
                            <Typography color="#D5B458" fontSize={20}>{row.velocity} </Typography>
                          </Box>
                        </Box>
                      </StyledTableCell>

                    </StyledTableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </Box>
      )}
    </>

  );
}
